import { cn } from '@/lib/utils';

export function Brand({ compact }: { compact?: boolean }) {
  return (
    <div className={cn('flex h-14 items-center gap-2.5', compact ? 'justify-center' : 'px-3')}>
      <svg viewBox="0 0 32 32" className="size-7 shrink-0" aria-hidden>
        <rect width="32" height="32" rx="9" fill="var(--color-raised)" />
        <rect x="9" y="7" width="3" height="18" rx="1.5" fill="#3a3d45" />
        <rect x="15" y="7" width="3" height="18" rx="1.5" fill="#3a3d45" />
        <rect x="21" y="7" width="3" height="18" rx="1.5" fill="#3a3d45" />
        <rect x="6" y="14.5" width="20" height="3" rx="1.5" fill="var(--color-signal)" />
      </svg>
      {!compact && (
        <span className="text-[15px] font-semibold tracking-[-0.02em]">
          WorkFlow <span className="text-fg-muted">Cunae</span>
        </span>
      )}
    </div>
  );
}
